import { render, staticRenderFns } from "./AssignList.vue?vue&type=template&id=4ffed3cd&scoped=true&"
import script from "./AssignList.vue?vue&type=script&lang=js&"
export * from "./AssignList.vue?vue&type=script&lang=js&"
import style0 from "./AssignList.vue?vue&type=style&index=0&id=4ffed3cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffed3cd",
  null
  
)

export default component.exports